import React from 'react';
import i18n from 'translation';
import { Outlet } from 'react-router-dom';

import { Typography, Box, useTheme } from '@mui/material';

export default function PrimaryNavigation(): JSX.Element {
  const theme = useTheme();

  return (
    <Box sx={{ minHeight: "100dvh", position: "relative", display: "flex", flexDirection: "column" }}>
      { /* Container for wrapped component (the page / content area) */}
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      { /* Area for copyright / footer text */}
      <Box sx={{ width: "100%", textAlign: "center", paddingTop: 10, paddingBottom: "5px" }}>
        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
          Copyright ©{new Date().getFullYear()} Infegy, Inc. {i18n.t("copyright-rights")}
        </Typography>
      </Box>
    </Box>
  )
}